import {
  MULTICURRENCY_RECHARGE,
  MULTICURRENCY_PAYCONFIRM
} from "../apis/payment";

var payScript;
var anglPayEmbed;

export default {
  data() {
    return {
      query_timer: 0,
      query_pay_num: 0
    };
  },
  methods: {
    loadScriptSdk(type, success) {
      let _script = { src: "", sdk: null };
      if (type === "AnglPay") {
        _script.sdk = "gr4vy";
        _script.src = "https://cdn.anglpay.gr4vy.app/embed.latest.js";
      }
      if (_script.sdk && !window[_script.sdk]) {
        payScript = window.document.createElement("script");
        payScript.src = _script.src;
        payScript.onload = () => {
          console.log("payScript 加载完成");
          success && success();
        };
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        head.insertBefore(payScript, head.firstChild);
      } else {
        console.log("payScript 已加载");
        success && success();
      }
    },
    // 多货币支付方式
    onMulticurrencyPayment(param, callback) {
      this.MulticurrencyRecharge(param, callback);
    },
    /** 多货币充值方式
     * https://app.apifox.com/link/project/1121455/apis/api-265418758
     */
    async MulticurrencyRecharge(param, callback) {
      try {
        let rechargeType = "preAuth";
        if (this.payType === "PO") rechargeType = "pay";
        if (this.payType === "VIP") rechargeType = "vip";
        if (this.Query && this.Query.paymentWay.includes("PAYMENT")) {
          rechargeType = "preAuth";
        }
        const query = {
          ...param,
          paymentId: this.pId,
          amount: this.price || "",
          rechargeType: rechargeType,
          userOpenId: this.user.p_openID,
          rentNow: rechargeType === "preAuth",
          qrCode: this.qrcode || this.$route.query.cabinetID || ""
        };
        if (this.payMode === "CyberSource") {
          this.onCyberSourcePay(query, () => {});
          return;
        }

        const headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        this.$loading(true);
        const { data = {} } = await this.$Request(
          "POST",
          MULTICURRENCY_RECHARGE,
          query,
          headers
        );
        const Payment = this.selectPayment || { paymentMethodType: "" };
        if (data.outTradeNo && Payment.paymentMethodType.includes("Alipay")) {
          this.queryPaymentConfirm(data, callback);
          window.location.href = data.paymentInfo.payUrl;
          return false;
        }
        if (data.outTradeNo && data.approvalUrl) {
          window.location.href = data.approvalUrl;
          return false;
        }
        if (data.outTradeNo && data.paymentType.includes("AnglPay")) {
          this.$loading(false);
          this.onAnglPayPayment(query, data, transaction => {
            this.$loading(true);
            this.MulticurrencyConfirm(data.outTradeNo, transaction.id)
              .then(result => {
                this.$loading(false);
                callback && callback(result);
              })
              .catch(err => {
                this.$loading(false);
                this.$toast(err);
              });
          });
          return false;
        }
        throw new Error(data.message);
      } catch (err) {
        this.$loading(false);
        this.$toast(err);
        console.warn("Multicurrency ~ err:", err);
      }
    },
    // 多货币确认支付方式
    async MulticurrencyConfirm(outTradeNo, tradeNo) {
      const query = { outTradeNo: outTradeNo || "", tradeNo: tradeNo || "" };
      const { data = {} } = await this.$Request(
        "GET",
        MULTICURRENCY_PAYCONFIRM,
        query
      );
      return data;
    },
    // 查询支付确认
    async queryPaymentConfirm(Payment, callback) {
      if (this.query_pay_num > 12) {
        clearTimeout(this.query_timer);
        this.query_pay_num = 0;
        return false;
      }
      const callbackCell = result => {
        if (result && result.orderStatus === 1) {
          this.$loading(false);
          callback && callback(Payment);
        } else {
          this.query_pay_num++;
          this.query_timer = setTimeout(() => {
            this.queryPaymentConfirm(Payment, callback);
          }, 2200);
        }
      };
      if (Payment.outTradeNo) {
        await this.MulticurrencyConfirm(Payment.outTradeNo, Payment.tradeNo)
          .then(result => {
            callbackCell(result);
          })
          .catch(res => {
            callbackCell(res);
          });
      }
    },
    /**
     * AnglPay 支付确认
     */
    onAnglPaySetup() {
      anglPayEmbed.submit();
    },
    /** AnglPay支付方式 */
    onAnglPayPayment(payInfo, result, callback) {
      const paymentInfo = result.paymentInfo || payInfo || {};
      try {
        const _payInfo = {
          element: "#anglpay_dom",
          token: paymentInfo.embedToken,
          amount: paymentInfo.amount,
          currency: paymentInfo.currency,
          intent: paymentInfo.intent,
          buyerId: paymentInfo.buyerId,
          gr4vyId: paymentInfo.gr4vyId || "spider", // gr4vyId or iframeHost/apiHost
          environment: paymentInfo.environment || "production", // sandbox or production
          country: paymentInfo.country || process.env.VUE_APP_COUNTRY,
          onComplete: transaction => {
            console.log("onComplete ~ transaction:", transaction);
            callback && callback(transaction);
          },
          onCustomSubmit: transaction => {
            console.log("onCustomSubmit ~ transaction:", transaction);
          }
        };
        if (paymentInfo.merchantId) {
          _payInfo.merchantAccountId = paymentInfo.merchantId;
        }
        if (result.outTradeNo) _payInfo.externalIdentifier = result.outTradeNo;
        // if (result.checkoutSessionsId) _payInfo.checkoutSessionsId = result.checkoutSessionsId;
        this.isAnglPaySetup = true;
        console.info("gr4vy ~ _payInfo:", _payInfo);
        anglPayEmbed = window.gr4vy.setup(_payInfo);
        anglPayEmbed.submit();
      } catch (error) {
        this.isAnglPaySetup = false;
      }
    }
  }
};
